export enum LogisticProviderCode {
  'apg' = 'APG',
  'aramex' = 'ARAMEX',
  'dhl' = 'DHL',
  'fedex' = 'FEDEX',
  'speedpost' = 'SPEEDPOST',
  'tnt' = 'TNT',
  'ups' = 'UPS',
}
